module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms2_m.5bc73a426d4fce2247e810156d2c3f4b.png";